import React from 'react';
import { useLocation } from 'react-router-dom';

import Page from './layout/Page';
import Card from './layout/Card';
import { ReactComponent as IconSendCallInstructions } from '../assets/icons/reply-send-instruction.svg';
import { ReactComponent as IconForwardCall } from '../assets/icons/reply-forward-call.svg';
import { ReactComponent as IconCall } from '../assets/icons/reply-call.svg';
import { ReactComponent as IconFooterAddressBookMenuBarAction } from '../assets/icons/menu-address-book-action.svg';


import {forwardCall} from '../api';
import {showError} from "../utils";
import {useNavigate} from "react-router-dom";
import useAlert from '../hooks/useAlert';

export default function ChiamataAzioni() {
    

    const navigate = useNavigate();
    const alert = useAlert();

    const location = useLocation();
    const { id, numero, chiamante_title } = location.state || {};

    const handleForwardCallClick = async () => {
        try {
            await forwardCall(id);
            alert({message: "Segretaria avvisata con successo!"});
        } catch (e) {
            showError([e.message]);
        }
    };

    return (
        <Page title="Rispondi">
            <Card title={chiamante_title} content={numero} variant="call-base-info" />
            <Card title="Chiama / Inoltra Chiamata" content="Avvisa la segretaria di richiamarti il contatto e passartelo" icon={<IconFooterAddressBookMenuBarAction />} action={() => handleForwardCallClick()} />
            <Card title="Chiama" content="Chiama direttamente il contatto" icon={<IconCall />} action={() => window.location.href = `tel:${numero}`} />
            <Card title="Invia Istruzioni" content="Manda istruzioni alla segretaria su questo contatto" icon={<IconSendCallInstructions />} action={() => navigate('/call-action-invia-istruzioni', {state: { id, numero, chiamante_title }})} />            
        </Page>
    );
}
